import React, { useState } from "react";
import { Button, Container, Typography } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import axios from "axios";

const UploadPDF = () => {
    const [file, setFile] = useState<File | null>(null);
    const [uploadResult, setUploadResult] = useState<string | null>(null);

  const handleFileChange = (event:any) => {
    const selectedFile = event.target.files?.[0] || null;
    setFile(selectedFile);
  };
  
  const handleUpload = async (event: React.FormEvent) => {
    event.preventDefault();
    if (!file) return;
  
    const reader = new FileReader();
    reader.onloadend = async () => {
      if (typeof reader.result === "string") {
        const base64 = reader.result.split(",")[1];
  
        const formData = new FormData();
        formData.append("base64", base64);
        formData.append("filename", file.name); // ✅ No more error
        formData.append("mimeType", file.type);
  
        try {
          const response = await axios.post(
            "https://script.google.com/macros/s/AKfycbz8Hjo3ob3V0VWuuTPaSN-HiPToiOou8-eMVP3e7zq4Ya1JsPluudIoOz6xFgc7_lrv/exec?action=doPostResume",
            formData
          );
  
          if (response.data.success) {
            setUploadResult(response.data.url);
          } else {
            setUploadResult("Upload failed: " + response.data.error);
          }
        } catch (error) {
          setUploadResult("Upload failed: " + error);
        }
      } else {
        setUploadResult("Error: File reading failed.");
      }
    };
  
    reader.readAsDataURL(file);
  };
  
  

  return (
    <Container maxWidth="sm" style={{ textAlign: "center", marginTop: "20px" }}>
      <Typography variant="h4" gutterBottom>
        Upload PDF
      </Typography>
      <input type="file" accept="application/pdf" onChange={handleFileChange} />
      <Button
        variant="contained"
        color="primary"
        startIcon={<CloudUploadIcon />}
        onClick={handleUpload}
        disabled={!file}
        style={{ marginTop: "10px" }}
      >
        Upload
      </Button>
      {uploadResult && (
        <Typography variant="body1" style={{ marginTop: "10px" }}>
          {typeof uploadResult === "string" && uploadResult ? (
            <a href={uploadResult} target="_blank" rel="noopener noreferrer">
              View PDF
            </a>
          ) : (
            uploadResult
          )}
        </Typography>
      )}
    </Container>
  );
};

export default UploadPDF;
